import { useGetApplication } from 'app/hooks';
import { type AttachmentDefinition, type TaxReportGeneralInfo } from 'app/modules/Reports/types';
import moment from 'moment';

const baseUrl = '/reports';
export const useGetTaxReportGeneral = (id: string) => {
  const [{ data, loading, error }] = useGetApplication<TaxReportGeneralInfo>({
    url: `${baseUrl}/tax-reports/${id}/general`,
    params: {}
  });

  const general = {
    ...data,
    createdDate: data ? moment(data.createdDate).toDate() : null
  } as TaxReportGeneralInfo;
  return { data: general, loading, error };
};

export const useGetReportAttachmentDefinition = (
  code: number,
  year: number,
  periodicityItem?: string
) => {
  const [{ data, loading, error }] = useGetApplication<AttachmentDefinition>({
    url: `/taxpayers/report/${code}/${year}/attachment/definition`,
    params: { periodicityItem }
  });

  return { data, loading, error };
};
